export default "__VITE_ASSET__DvRSEdJg__"